import React from 'react';
import { Input } from '../../ui/Input';
import { CreatableSelect } from '../../ui/CreatableSelect';
import { useTrainingOptions } from '../../../hooks/useTrainingOptions';
import { parseAmount } from '../../../utils/currency';
import { TrainingCourseDraft } from '../../../types/trainingCourse';
interface CourseCostsFieldsProps {
  draft: TrainingCourseDraft;
  onChange: (changes: Partial<TrainingCourseDraft>) => void;
}
type AmountKey = 'equipmentAmount' | 'roomRentalAmount' | 'otherCostsAmount' | 'externalCostAmount';
export function CourseCostsFields({
  draft,
  onChange
}: CourseCostsFieldsProps) {
  const {
    options,
    addOption
  } = useTrainingOptions();
  const amountInput = (key: AmountKey, label: string) => <Input label={label} type="number" min={0} step="0.01" value={draft[key] ?? ''} onChange={e => onChange({
    [key]: parseAmount(e.target.value)
  } as Partial<TrainingCourseDraft>)} endContent={<span className="text-xs" data-id="element-1083" data-mp="3tk4n1b6b45st">€</span>} data-id="element-1082" data-mp="1xdmf3k652ub" />;
  return <div className="divide-y divide-slate-100" data-id="element-1084" data-mp="3thidj5zuvg7y">
      <section className="pb-6" data-id="element-1085" data-mp="3ok8inatp6ccq">
        <h3 className="text-sm font-semibold text-seform-navy mb-4" data-id="element-1086" data-mp="3olb77c3js2ph">
          Noleggio attrezzature
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1087" data-mp="3jni0mhyc16oo">
          <CreatableSelect label="Tipologia" value={draft.equipmentType || ''} onChange={v => onChange({
          equipmentType: v || undefined
        })} options={options.equipmentType} onCreate={v => addOption('equipmentType', v)} placeholder="Seleziona tipologia..." newPlaceholder="Inserisci nuova tipologia" data-id="element-1088" data-mp="3fj1x2nc6ybcm" />
          {amountInput('equipmentAmount', 'Importo complessivo')}
        </div>
      </section>

      <section className="py-6" data-id="element-1089" data-mp="2rt7ncen652wl">
        <h3 className="text-sm font-semibold text-seform-navy mb-4" data-id="element-1090" data-mp="2rtg2yeaoembh">
          Affitto locali
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1091" data-mp="2mx91oyt85yzv">
          {amountInput('roomRentalAmount', 'Importo complessivo')}
        </div>
      </section>

      <section className="py-6" data-id="element-1092" data-mp="2ha6zb6ko65gq">
        <h3 className="text-sm font-semibold text-seform-navy mb-4" data-id="element-1093" data-mp="2h7189lshctid">
          Altri costi
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1094" data-mp="23bgwrbf2zdkz">
          {amountInput('otherCostsAmount', 'Importo complessivo')}
        </div>
      </section>

      <section className="pt-6" data-id="element-1095" data-mp="2vzct2f0qn3h8">
        <h3 className="text-sm font-semibold text-seform-navy mb-4" data-id="element-1096" data-mp="2w04nvnmigx6g">
          Costo prodotto esterno
        </h3>
        {draft.externalProduct ? <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1097" data-mp="2m9084lp0h8ak">
            {amountInput('externalCostAmount', 'Importo complessivo del costo del prodotto')}
            <CreatableSelect label="Denominazione fornitore" value={draft.externalSupplier || ''} onChange={v => onChange({
          externalSupplier: v || undefined
        })} options={options.supplier} onCreate={v => addOption('supplier', v)} placeholder="Seleziona fornitore..." newPlaceholder="Inserisci nuovo fornitore" data-id="element-1098" data-mp="3evus7hhx25ni" />
          </div> : <p className="text-sm text-slate-500" data-id="element-1099" data-mp="1h2s4sph76frb">
            Disponibile solo con il flag «Acquisto prodotto esterno» attivo
            (in Dati corso).
          </p>}
      </section>
    </div>;
}